// eslint-disable-next-line import/no-anonymous-default-export
export default text => {
  const wpm = 225;
  const words = text.replace(/(<([^>]+)>)/ig, '').trim().split(/\s+/).length;

  return Math.ceil(words / wpm);
}
